import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { KindOfOrder } from "../../../../types/enums";
import { MessageRecipientsResult } from "../types/MessageRecipientsResult";

export const useGetMessageRecipients = (orderID: number, kindOfOrder: KindOfOrder) => {

    const { data, isLoading } = useQuery({
        queryKey: ['recipients', orderID, kindOfOrder],
        queryFn: async () => await apiClient.get('communication/recipients',
            { params: { orderID: orderID, kindOfOrder: kindOfOrder } }) as MessageRecipientsResult
    });

    return {
        data,
        isLoading
    };
};
